<template>
  <image-display :caption="'Current sky'" :popover-content="popoverText" :img-src="allskyImgSrc"></image-display>
</template>

<script>
  /* TODO: Push this module into the session status */
  import 'rti.css';
  import Axios from 'axios';
  import ImageDisplay from './imageDisplay.vue';

  export default {
    components: {ImageDisplay},
    name: 'allsky',
    props: ['telescope'],
    data: function() {
      return {
        testSites: ['bpl', 'tst'],
        baseURL: 'https://lco.global',
        imageNotFound: 'loading.jpg',
        url: '',
        allskyUpdateMin: 4 /* An updated image is only made available every 4 minutes */,
        allskyImage: '',
        popoverText: `Image of the sky at the current site. Contains a timestamp of when it was taken in the top left
        corner. The image is usually updated about every 4 minutes. However, sometimes images are not regularly updated
        due to network issues.`
      };
    },
    mounted: function() {
      if (!this.telescope) {
        this.url = this.imageNotFound;
        return;
      }

      for (let site in this.testSites) {
        if (this.testSites[site] === this.telescope.site.toLowerCase()) {
          this.url = this.imageNotFound;
          return;
        }
      }
      this.url = this.baseURL + '/camera/data/' + this.telescope.site + '/allsky/lastsnap.jpg';

      /* FIXME: Change Allsky to support CORS, we can't check if the URL works or not without this */
      /*
      this.getAllskyImage();
      window.setInterval(
        this.getAllskyImage, (1000 * 60) * this.allskyUpdateMin
      );
      */
    },
    computed: {
      allskyImgSrc: function() {
        let allskyImage = 'data:image/jpeg;base64, ' + this.allskyImage;
        let defaultImage = 'loading.jpg';

        //return this.allskyImage ? allskyImage : defaultImage;
        return this.url;
      }
    },
    methods: {
      getAllskyImage: function() {
        Axios.get(this.url, {
          responseType: 'arraybuffer',
          headers: {
            'Access-Control-Allow-Origin': '*'
          }
        }).then(response => {
          this.allskyImage = new Buffer(response.data, 'binary').toString('base64');
        }).catch((error) => {
          console.error(error);
        });
      }
    }
  };
</script>
